import * as React from 'react';
import IconBook from '../images/icn_vault_book.inline.svg';
import Article from '../images/icn_vault_computer.inline.svg';
import Podcast from '../images/icn_vault_microphone.inline.svg';
import Video from '../images/icn_vault_video.inline.svg';
import ModernSecuritySVG from '../images/icn_modern_security.svg';
import EnablerSVG from '../images/icn_enabler_of_innovation.svg';
import BuildingAppsSVG from '../images/icn_building_applications.svg';
import OpenSourceSVG from '../images/icn_open_source.svg';
import AssetMgmtSVG from '../images/icn_asset_management.svg';
import DefaultDOK from '../images/dept-of-know.svg';

type IconSVGProps = {
  variant: string | undefined;
};

interface IconsType {
  [key: string]: string;
}

export const IconSVG = ({ variant }: IconSVGProps): JSX.Element => {
  const normalizeVariant: string = variant ? variant.toLowerCase() : 'default';

  const icons: IconsType = {
    book: IconBook,
    podcast: Podcast,
    video: Video,
    article: Article,
    modernsecurity: ModernSecuritySVG,
    enableinnovation: EnablerSVG,
    buildingapps: BuildingAppsSVG,
    opensource: OpenSourceSVG,
    assetmgmt: AssetMgmtSVG,
    default: DefaultDOK,
  };

  const ImportSVG: string = icons[normalizeVariant];

  return <ImportSVG />;
};
